import { Path } from '~/routes/constants';
import { CacheTag, CacheTagWithId } from '../CacheTag';

export const getUpdateInquiryInvalidationTagsByPathname = (
  pathname: string,
  inquiryId: string | undefined,
  patientId: string | undefined,
): (CacheTag | CacheTagWithId)[] => {
  const tagsToInvalidate: (CacheTag | CacheTagWithId)[] = [
    { id: inquiryId, type: CacheTag.Inquiry },
  ];

  // Always include all patient-related tags, even if patientId is undefined
  const patientTags = [
    { id: patientId, type: CacheTag.GetPatientById },
    { id: patientId, type: CacheTag.PatientInquiries },
    { id: patientId, type: CacheTag.PatientCoveragesById },
    { id: patientId, type: CacheTag.PatientContactById },
    { id: inquiryId, type: CacheTag.PatientContactById },
  ];

  if (pathname?.includes(Path.MAUD_PATIENTS)) {
    tagsToInvalidate.push(
      ...patientTags,
      { id: patientId, type: CacheTag.PatientInquiriesSummary },
      { id: patientId, type: CacheTag.PatientTreatmentEpisodes },
      { id: patientId, type: CacheTag.PatientClinicalProfile },
      { id: patientId, type: CacheTag.PatientProviderTeamAssignments },
    );
  } else if (pathname?.includes(Path.MAUD_INQUIRIES)) {
    tagsToInvalidate.push(...patientTags);
  }

  return tagsToInvalidate;
};
